<template>
  <div class="lv-card-list__container">
    <LvCard
      v-for="(item,itemIndex) in items"
      :key="itemIndex"
      :tags="item.tags"
      :spec="item.spec"
      :chips="item.chips"
      :title="item.title"
      :hasTopBar="hasTopBar"
      :factoryTags="item.factoryTags"
      :bannerUrl="item.bannerUrl"
      :specTitleFontSize="specTitleFontSize"
      :specTextFontSize="specTextFontSize"
      :iconBtnList="item.iconBtnList"
      class="lv-card-list__items"
      @click="$_onClickItem(item)"
      @click-icon="$emit('click-icon', $event)"
      @click-icon-btn="$emit('click-icon-btn', {columnHeaderItemId: $event, rowItem: item.rowItem ? item.rowItem : item})"
    >
      <template v-slot:header>
        <slot name="header" :item="item"/>
      </template>
       <template v-slot:footer>
        <slot name="footer" :item="item"/>
      </template>
    </LvCard>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
    },
    hasTopBar: {
      type: Boolean,
      default: false,
    },
    specTitleFontSize: {
      type: String,
      default: 'h6',
    },
    specTextFontSize: {
      type: String,
      default: 'h6',
    },
  },
  methods: {
    $_onClickItem(item) {
      this.$emit('click', item.id);
      this.$emit('click-item', item);
    },
  }
}
</script>